export default __webpack_public_path__ + "83ac8e66e452f1dba1915b81b908411b.png";